/* Form Component.
 *
 * onSubmit can be a string indicating the name of the endpoint
 * to post to on our server, or a custom function that returns
 * a promise
 */

import { createContext, useContext, useState } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import useAppState from "../providers/AppProvider";
import API from "../utilities/API";

const FormContext = createContext({});

FormProvider.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  additionalData: PropTypes.object,
  showSuccess: PropTypes.bool,
};

FormProvider.defaultProps = {
  children: PropTypes.node,
  onSubmit: "contact_us",
  additionalData: {},
  showSuccess: true,
  thankYouContent: null,
};

export default function FormProvider({
  children,
  onSubmit,
  additionalData,
  showSuccess,
  thankYouContent,
}) {
  const methods = useForm();
  const { handleSubmit } = methods;
  const { currentPropertySettings } = useAppState();
  console.log(
    "%c currentPropertySettings",
    "color: yellow",
    currentPropertySettings
  );
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  console.log("%c additionalData", "color: red", additionalData);
  const sendToCendyn = currentPropertySettings?.buttontext1;

  const renderFields = () => !(success && showSuccess) && children;

  const renderThankYou = () =>
    success &&
    showSuccess && (
      <div className="form__thank_you">
        {thankYouContent ? thankYouContent : <p>Thanks for your submission.</p>}
      </div>
    );

  const renderError = () =>
    error &&
    !success && (
      <div>
        <p>{error}</p>
      </div>
    );

  async function cendynSubmit(formData) {
    const cendynData = JSON.stringify({
      PostData: {
        emailAddress: formData.email,
      },
    });
    const formID = currentPropertySettings?.buttontext1;
    const cendynUrl = `https://web2.cendynhub.com/FormsRest/submit/${formID}?format=json`;

    //Write using fetch
    fetch(cendynUrl, {
      method: "POST",
      body: cendynData,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("%c data", "color: red", data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const submitHandler = handleSubmit((formData) => {
    let api = new API({ base: API_PATH });
    let submit = api.post.bind(api, onSubmit);

    if (typeof onSubmit === "function") {
      submit = onSubmit;
    }

    const cumulativeData = {
      ...formData,
      ...additionalData,
    };
    const finalData = {
      ...cumulativeData,
    };

    submit(finalData)
      .then((resp) => {
        if (resp.error) {
          return setError(error.message || "An error occurred.");
        }
        if (sendToCendyn) {
          cendynSubmit(formData);
        }
        setSuccess(true);
      })
      .catch((error) => {
        console.error(error);
        setError(error.message || "An error occurred.");
      });
  });

  return (
    <FormContext.Provider value={methods}>
      <form className="form" onSubmit={submitHandler}>
        {renderFields()}
        {renderThankYou()}
        {renderError()}
      </form>
    </FormContext.Provider>
  );
}

export function useFormContext() {
  return useContext(FormContext);
}
